
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";
import { Options } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import Duplicar from "./_Duplicar.vue";
import { labelStatusQts } from "./constantes";

@Options({
    name: "QtsSemanalIndex",
    components: { CardRh, KDataTable, Cadastro, Editar, Duplicar },
})
export default class QtsSemanalIndex extends IndexModelTable {
    @Prop() readonly turma!: any

    public turmaId: any = null;
    public search = '';
    public modal_duplicar = 'modal_qts_semanal_duplicar';
    public dadosDuplicar: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => { this.reloadDatatable = !this.reloadDatatable; }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) { this.refreshTable(); }
    }

    public limparFiltros() {
        this.search = '';
        this.refreshTable();
    }

    private fmtData(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    created() {
        this.service = new QtsSemanalService();
        this.turmaId = this.$route.params.id;
        this.modal_atualizar = 'modal_qts_semanal_update';

        this.config.order = [[0, 'desc']];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                return {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turmaId,
                    search: this.search || d.search.value,
                };
            }
        };

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'descricao', name: 'descricao' },
            { data: 'inicio', name: 'inicio', orderable: false, searchable: false }, 
            { data: 'status', name: 'status', class: 'text-center' },
            { data: 'observacao', name: 'observacao', class: 'text-center' },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row, type, full) => {
                    const ini = this.fmtData(full.inicio);
                    const fim = this.fmtData(full.fim);
                    return ini || fim ? `${ini} a ${fim}` : '-';
                },
            },
            {
                targets: 3,
                render: (row) => labelStatusQts(row),
            },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) { buttom = buttom + ' data-' + key + '="' + val[key] + '"'; }
                        texto += '<button class="btn btn-pmes-primary btn-sm" btn-ver ' + buttom + ' title="Detalhes"><i class="fa fa-eye"></i></button>';
                        if (this.hasPermissaoEditar) {
                            texto += '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                                this.modal_atualizar + '" title="Editar"><i class="fa fa-edit"></i></button>';
                            texto += '<button class="btn btn-light-pmes-dark-primary border border-pmes-dark-primary btn-sm" btn-duplicar ' + buttom +
                                ' data-bs-toggle="modal" data-bs-target="#' + this.modal_duplicar + '" title="Duplicar"><i class="fa fa-copy"></i></button>';
                            texto += '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' title="Excluir"><i class="fa fa-trash"></i></button>';
                        }
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-ver]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'sigap_turma_qts_gerador_qtssemanal_show', params: { id: this.turmaId, qtsSemanalId: id } });
        });
        $('[btn-editar]').click((btn) => {
            this.dados = null;
            setTimeout(() => { this.dados = $(btn.currentTarget).data(); }, 10);
        });
        $('[btn-duplicar]').click((btn) => {
            this.dadosDuplicar = null;
            setTimeout(() => { this.dadosDuplicar = $(btn.currentTarget).data(); }, 10);
        });
        $('[btn-excluir]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
    }

    public aoDuplicado(novoId: any) {
        if (novoId) {
            this.$router.push({ name: 'sigap_turma_qts_gerador_qtssemanal_show', params: { id: this.turmaId, qtsSemanalId: novoId } });
        } else {
            this.reloadDatatable = !this.reloadDatatable;
        }
    }

    protected excluirModelo(id) {
        SiteUtils.alertConfimacao('Confirma a Exclusão', '',
            () => {
                this.processando = true;
                setTimeout(() => {
                    this.service.excluir(id)
                        .then(() => {
                            this.reloadDatatable = !this.reloadDatatable;
                            SiteUtils.toastSucesso('Exclusão realizada com sucesso!!');
                            this.processando = false;
                        })
                        .catch(error => {
                            this.processando = false;
                            SiteUtils.toastErro('Não foi possível Excluir', error?.data?.message);
                        });
                }, 10);
            }
        );
    }
}
